import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchCreateFolder } from '../repositories/favorites/v1/create-folder';
import { addNewFolder } from '../actions';
import { mapCreateFolderResponse } from '../mappers';
export var createFolder = function createFolder(name) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var httpApi, logger, parameters, _yield$fetchCreateFol, statusCode, response, folder;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            httpApi = _ref.httpApi, logger = _ref.logger;
            parameters = {
              name: name
            };
            _context.prev = 2;
            _context.next = 5;
            return fetchCreateFolder({
              httpApi: httpApi,
              parameters: parameters
            });
          case 5:
            _yield$fetchCreateFol = _context.sent;
            statusCode = _yield$fetchCreateFol.statusCode;
            response = _yield$fetchCreateFol.response;
            if (!(statusCode === 200)) {
              _context.next = 12;
              break;
            }
            folder = mapCreateFolderResponse(response);
            dispatch(addNewFolder({
              folder: folder
            }));
            return _context.abrupt("return", response);
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            logger.error(_context.t0, {
              description: 'Fail to create favorites folders'
            });
          case 17:
            return _context.abrupt("return", null);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 14]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};